import React, {RefObject} from 'react';
import './styles.css';
import HelpIcon from './HelpIcon';
import {helpFloatingButtonText} from '../texts/helpFloatingButtonText';
import {HelpItem} from '../config/helpItems';

interface Props {
  isOpen: boolean;
  items: HelpItem[];
  containerRef: RefObject<HTMLDivElement>;
  onToggle: () => void;
  onItemClick: (item: HelpItem) => void;
}

const HelpFloatingButtonUI: React.FC<Props> = ({
  isOpen,
  items,
  containerRef,
  onToggle,
  onItemClick,
}) => {
  return (
    <div className="helpFloatingButtonContainer" ref={containerRef}>
      {isOpen && (
        <div className="helpFloatingMenu" role="menu">
          {items.map(item => (
            <button
              key={item.id}
              className="helpFloatingMenuItem"
              role="menuitem"
              onClick={() => onItemClick(item)}>
              {helpFloatingButtonText[item.labelKey]}
            </button>
          ))}
        </div>
      )}
      <button
        type="button"
        className="helpFloatingButton"
        onClick={onToggle}
        aria-label={helpFloatingButtonText.ariaLabel}
        aria-haspopup="menu"
        aria-expanded={isOpen}>
        <HelpIcon />
      </button>
    </div>
  );
};

export default React.memo(HelpFloatingButtonUI);
